import { Dialog, Button, DialogTitle, DialogContentText, DialogActions, DialogContent } from '@mui/material';
import { toTitleCase } from '../../../utils';
import { useContent } from '../../../logic';

interface ResetTaskDialogProps {
    open: boolean;
    setUserResetOpen: (open: boolean) => void;
    onUserResetTask: () => void;
}

export function ResetTaskDialog({ open, setUserResetOpen, onUserResetTask }: ResetTaskDialogProps) {

  const { TaskText } = useContent()

  return <Dialog key="userReset" open={open}>
    <DialogTitle>Restart {toTitleCase(TaskText)}</DialogTitle>

    <DialogContent>
      <DialogContentText sx={{ mb: 1 }}>
                Are you sure you want to restart this {TaskText}?
      </DialogContentText>
      <DialogContentText>
                Restarting will allow you to complete this {TaskText} from the
                beginning.
      </DialogContentText>
    </DialogContent>

    <DialogActions>
      <Button variant="contained" onClick={() => setUserResetOpen(false)}>
                No
      </Button>
      <Button variant="rounded" onClick={onUserResetTask}>
                Yes, restart it
      </Button>
    </DialogActions>
  </Dialog>
}